import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { adminApi } from '../adminApi';
import { CatalogCategoryFormState, createCatalogCategoryPayload } from './catalogFormValues';

export function useCatalogCategoryQuery(entityId?: number) {
  return useQuery({
    queryKey: ['catalog', 'category', entityId],
    enabled: entityId !== undefined,
    queryFn: async () => {
      const result = await adminApi.getCatalogCategories({ category_id: entityId, page: 1, per_page: 1 });
      const entity = result.items.find((item) => item.category_id === entityId);
      if (!entity) throw new Error('Категория не найдена.');
      return entity;
    },
  });
}

export function useCatalogCategorySave(entityId?: number) {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (values: CatalogCategoryFormState) => {
      if (entityId === undefined) {
        const payload = createCatalogCategoryPayload(values);
        return adminApi.createCatalogCategory(payload);
      }
      const payload = createCatalogCategoryPayload(values);
      return adminApi.updateCatalogCategory(entityId, payload);
    },
    onSuccess: () => client.invalidateQueries({ queryKey: ['catalog'] }),
  });
}
